<template>
    <div id="product-variations">
        <div v-if="!product.is_clothing && sizes && sizes.length > 1" class="text-yanone">
            <SelectField v-model="selectedPhoneModel" label="Marca:" v-if="isPhone">
                <option :value="null">
                    Selecione a marca
                </option>
                <option v-for="model in phoneModels" :value="model">
                    {{ model }}
                </option>
            </SelectField>
            <SelectField :value="selectedSize" @change="$emit('input', $event)"
                         :label="label ? label : (isPhone ? 'Modelo:' : '')"
                         :disabled="isPhone && !selectedPhoneModel">
                <option v-if="isPhone" :value="null">
                    Selecione seu aparelho
                </option>
                <option v-else :value="null">
                    Selecione o tamanho
                </option>
                <option v-for="item in selectOptions" :value="item"
                        :disabled="shopMode && (! product.in_stock || (item.quantity === 0 && !item.virtual_stock))">
                    {{ item.size_name }}
                    <template v-if="!reprintMode">
                        <span v-if="! product.in_stock || (!item.virtual_stock && item.quantity === 0)">&nbsp;-&nbsp;Esgotado</span>
                        <span
                            v-else-if="!item.virtual_stock && item.quantity === 1">&nbsp;-&nbsp;Resta {{
                                item.quantity
                            }}</span>
                        <span
                            v-else-if="!item.virtual_stock && item.quantity < 4">&nbsp;-&nbsp;Restam {{
                                item.quantity
                            }}</span>
                        <span v-if="product.price_min > 0">
                            &nbsp;-&nbsp;
                            <span v-if="item.price_old">De {{ item.price_old|formatMoney }} Por</span>

                            <span v-if="item.price">{{ item.price|formatMoney }}</span>
                            <span v-else>{{ product.price_old|formatMoney }}</span>
                        </span>
                    </template>
                </option>
            </SelectField>
        </div>
        <div v-else class="text-yanone">

            <p v-if="label" class="mt-0">{{ label }}</p>

            <div class="product-variations-types">

                <template v-if="colors && colors.length > 0">
                    <div v-if="hasDeliveryReadySizes">
                        <div class="d-inline-flex flex-align-center">
                            <span>
                                <input type="checkbox" class="cr-checkbox" id="only-delivery-ready"
                                       v-model="onlyDeliveryReady"/>
                                <label for="only-delivery-ready" class="text-left">
                                    Mostrar somente opções disponíveis em pronta-entrega
                                </label>
                            </span>
                            <span @click="showDeliveryReadyInfo = true">
                                <i class="cursor-pointer icon-cr icon-question-sign ml-1"></i>
                            </span>
                        </div>
                    </div>
                    <div class="inline-block">
                        <p class="h6">Cor: <strong>{{ selectedColor.name }}</strong></p>

                        <nav class="cr-option-group product-variations-colors">
                            <template v-for="(color, index) in colors">
                                <div
                                    class="cr-option cr-option-rounded"
                                    :class="{'cr-option-selected': (selectedColor || {}).id === color.id}"
                                    style="background-color: white; padding: 2px;"
                                    @click="setColor(color)">
                                    <div :style="{'background-color': color.code}"
                                         class="product-color-option"></div>
                                </div>
                                <!-- quebra linha -->
                                <div
                                    v-if="colors.length > (modelings.length > 1 ? 9 : 7) && index + 1 === Math.ceil(colors.length / 2)"
                                    class="hidden-md-down"
                                    style="flex-basis: 100%"/>
                            </template>
                        </nav>
                    </div>
                    <br/>
                </template>

                <template v-if="modelings && modelings.length > 0">
                    <div class="inline-block">
                        <div class="d-flex flex-align-baseline">
                            <p class="h6 flex-child-fixed">Modelagem:</p>
                            <p v-if="product.is_clothing && shopMode" class="text-right">
                                <span @click="scrollToTableSizes">
                                    &nbsp;<a class="text-underline">Ver medidas</a>
                                </span>
                            </p>
                        </div>

                        <div class="cr-option-group">
                            <nav v-for="modeling in modelings"
                                 class="cr-option cr-option-rounded flex-child-fixed"
                                 :class="{'cr-option-selected': (selectedModeling || {}).id === modeling.id}"
                                 @click="setModeling(modeling)">
                                {{ modeling.name }}
                            </nav>
                        </div>
                    </div>
                    <br/>
                </template>

                <template v-if="sizes && (sizes.length > 1 || product.is_clothing)">
                    <div class="inline-block">
                        <p class="h6">Tamanho:</p>

                        <nav class="cr-option-group"
                             :style="{'margin-bottom': sizes.some(s => sizeHasFewUnits(s)) ? '2rem' : null}">
                            <div v-for="size in sizes"
                                 class="cr-option cr-option-squared cr-option-rounded flex-child-fixed"
                                 :class="getSizeClasses(size)"
                                 :rel="`${size.gender}-${size.size_name}`"
                                 v-tooltip="shopMode && ((size.quantity === 0 && !size.virtual_stock) || ! product.in_stock) ? 'Esgotado (clique para ser avisado)' : null"
                                 @click="$emit('input', size)">
                                {{ size.size_name }}
                                <div v-if="sizeHasFewUnits(size)"
                                     class="cr-option-description">
                                    {{ size.quantity === 1 ? 'Resta ' : 'Restam ' }}{{ size.quantity }}
                                </div>
                            </div>
                        </nav>

                        <p v-if="selectedColor && selectedModeling && !hasAvailableSize && colors.length > 1"
                           class="text-secondary">
                            Nenhum tamanho disponível. Verifique a disponibilidade em outras cores acima.
                        </p>
                    </div>
                </template>
            </div>
        </div>

        <hr v-if="showSeparator"/>

        <DeliverReadyInfoModal v-model="showDeliveryReadyInfo"/>
    </div>
</template>

<script>
    import {EventBus, readUrlQuery} from "../../../common/common";
    import DeliverReadyInfoModal from "./DeliverReadyInfoModal";
    import SelectField from "@bit/chicorei.chicomponents.input.select-field";

    export default {
        name: "ProductVariationsOld",

        components: {DeliverReadyInfoModal, SelectField},

        model: {
            prop: 'selectedSize'
        },

        props: {
            product: {
                type: Object,
                required: true
            },
            selectedSize: {
                type: Object,
                default: null
            },
            label: String,
            reprintMode: Boolean,
            shopMode: Boolean,
            wishlistMode: Boolean,
        },

        data() {
            return {
                onlyDeliveryReady: false,
                showDeliveryReadyInfo: false,

                selectedColor: null,
                selectedModeling: null,
                selectedPhoneModel: null,
            }
        },

        watch: {
            selectedPhoneModel() {
                if (this.isPhone) {
                    this.$emit('input', null);
                }
            },

            colors(to) {
                if (to.length === 0) {
                    this.setColor(null);
                } else if (!to.find(c => c.id === (this.selectedColor || {}).id)) {
                    this.setColor(to[0]);
                }
            },

            modelings(to) {
                if (to.length === 0) {
                    this.setModeling(null);
                } else if (!to.find(m => m.id === (this.selectedModeling || {}).id)) {
                    this.setModeling(to[0]);
                }
            },
        },

        computed: {
            isPhone() {
                return (this.product.type || {}).id === 15;
            },

            showSeparator() {
                return this.shopMode && ((this.sizes && (this.sizes.length > 1 || this.product.is_clothing)) || (this.colors && this.colors.length > 0) || (this.modelings && this.modelings.length > 0));
            },

            hasDeliveryReadySizes() {
                return this.shopMode && this.product.in_stock && this.product.is_clothing && this.product.variations.some(v => v.quantity > 0);
            },

            variations() {
                return this.reprintMode ?
                    this.product.variations.filter(s => (s.quantity === 0 && !s.virtual_stock) || !this.product.in_stock) : this.product.variations;
            },

            hasAvailableSize() {
                if (!this.selectedColor || !this.selectedModeling) return null;

                for (const size of this.sizes) {
                    if ((size.quantity > 0 || size.virtual_stock) && this.product.in_stock) {
                        return true;
                    }
                }

                return false;
            },

            colors() {
                const colors = [];
                const selected = {};

                this.variations.filter(v => !this.onlyDeliveryReady || v.quantity > 0).forEach((variation) => {
                    if (!variation.product_color_id || selected[variation.product_color_id])
                        return;

                    selected[variation.product_color_id] = true;

                    colors.push({
                        id: variation.product_color_id,
                        color_id: variation.color_id,
                        name: variation.product_color_name,
                        code: variation.product_color_hexa,
                        fabric_id: variation.fabric_id,
                    });
                });

                return colors.sort((a, b) => {
                    return a.fabric_id === this.product.fabric_id ? -1 : 1;
                });
            },

            modelings() {
                const modelings = [];
                const selected = {};

                if (this.product.is_clothing) {
                    this.variations
                        .filter(v => (!this.onlyDeliveryReady || v.quantity > 0) && (!this.selectedColor || v.fabric_id === this.selectedColor.fabric_id))
                        .forEach((variation) => {
                            if (!variation.product_model_id || selected[variation.product_model_id])
                                return;

                            selected[variation.product_model_id] = true;

                            modelings.push({
                                id: variation.product_model_id,
                                name: variation.product_model_name,
                                gender: variation.gender,
                            });
                        });
                }

                return modelings.sort((a, b) => {
                    return a.id < b.id ? -1 : 1;
                });
            },

            sizes() {
                return this.variations.filter((variation) => {
                    if (this.onlyDeliveryReady && !variation.quantity)
                        return false;

                    if (this.selectedColor && this.selectedColor.id !== variation.product_color_id)
                        return false;

                    return !(this.selectedModeling && this.selectedModeling.id !== variation.product_model_id);
                });
            },

            phoneSizesByModel() {
                if (!this.isPhone)
                    return {};

                const modelSizes = {};

                this.sizes.forEach((variation) => {
                    const model = variation.size_name.split(' ')[0];

                    if (!modelSizes[model]) {
                        modelSizes[model] = [];
                    }

                    modelSizes[model].push(variation);
                });

                return modelSizes;
            },

            phoneModels() {
                return Object.keys(this.phoneSizesByModel).sort();
            },

            selectOptions() {
                if (this.isPhone) {
                    return this.selectedPhoneModel ? this.phoneSizesByModel[this.selectedPhoneModel] : [];
                }

                return this.sizes;
            }
        },

        created() {
            this.onlyDeliveryReady = this.shopMode && readUrlQuery('inPhysicalStock') === '1';

            let model;
            if (this.selectedSize && this.selectedSize.product_model_id) {
                model = this.modelings.find(m => m.id === this.selectedSize.product_model_id);
            } else {
                const gender = readUrlQuery('gender');
                if (gender && (gender === 'M' || gender === 'F')) {
                    model = this.modelings.find(m => m.gender === gender);
                }
            }

            if (model) this.setModeling(model);

            if (!this.selectedModeling && this.modelings.length > 0) {
                this.setModeling(this.modelings[0]);
            }

            let color;
            if (this.selectedSize && this.selectedSize.fabric_id) {
                color = this.colors.find(c => c.fabric_id == this.selectedSize.fabric_id);
            } else {
                const fabric = readUrlQuery('fabric');
                if (fabric) {
                    color = this.colors.find(c => c.fabric_id == fabric);
                }
            }

            if (color) this.setColor(color);

            if (!this.selectedColor && this.colors.length > 0) {
                this.setColor(this.colors[0]);
            }
        },

        methods: {
            setColor(color) {
                this.selectedColor = color;
                if (color) {
                    if (this.shopMode) {
                        EventBus.$emit('selected-color-change', color);
                    }
                    this.updateSelectedSize();
                }
            },

            setModeling(model) {
                this.selectedModeling = model;

                if (model) {
                    if (this.shopMode) {
                        EventBus.$emit('selected-modeling-change', model);
                    }
                    this.updateSelectedSize();
                } else {
                    this.$emit('input', null);
                }
            },

            updateSelectedSize() {
                if (this.selectedSize) {
                    const equivalentSize = this.sizes.find(s => s.size_id === this.selectedSize.size_id);

                    if (!equivalentSize || !this.product.in_stock || (!equivalentSize.virtual_stock && equivalentSize.quantity === 0)) {
                        this.$emit('input', null);
                    } else {
                        this.$emit('input', equivalentSize);
                    }
                }
            },

            scrollToTableSizes() {
                cr$.byId('table-sizes-anchor').scrollIntoView();
            },

            sizeHasFewUnits(size) {
                return this.shopMode && !size.virtual_stock && size.quantity > 0 && size.quantity < 4 && this.product.in_stock;
            },

            getSizeClasses(size) {
                return {
                    'cr-option-selected': this.selectedSize && size.variation_id === this.selectedSize.variation_id,
                    'cr-option-disabled': !this.wishlistMode && !this.reprintMode && ((size.quantity === 0 && !size.virtual_stock) || !this.product.in_stock),
                }
            },
        }
    }
</script>